<template>
    <ThumbnailList
        v-if="properties"
        :items="properties"
        :active-item="selectedLocation"
        :pending="pending"
        @click:item="handleClickLocation"
    >
        <template
            v-for="(property, index) in properties"
            :key="`property-${index}`"
            #[`item-${index}`]
        >
            <BaseDotLink
                :active="selectedLocation === property"
            >
                <DashedText>
                    <template #left>
                        {{ property.city?.[0]?.title }}
                    </template>
                    <template #right>
                        <template v-if="property.propertyPhase === 'comingSoon'">
                            {{ $t('coming-soon') }}
                        </template>
                        <template v-else>
                            {{ property.area }}
                        </template>
                    </template>
                </DashedText>
            </BaseDotLink>
        </template>
    </ThumbnailList>
</template>

<script setup>
import PropertiesQuery from '~/graphql/queries/properties.graphql';

const emit = defineEmits(['update:location']);

const { variables } = useCraftGraphql();

// Ignore the URI in this case
delete variables.uri;

const { pending, data } = await useLazyAsyncQuery({
    query: PropertiesQuery,
    variables
});

const properties = computed(() => {
    return data?.value?.entries.filter((property) => {
        return property.propertyPhase !== 'inDevelopment';
    });
});

const props = defineProps({
    selectedLocation: {
        type: Object,
        required: false,
        default: null
    }
});

const selectedLocation = toRef(props.selectedLocation);


function handleClickLocation(property) {
    if (selectedLocation.value === property) {
        selectedLocation.value = null;
        return;
    }

    selectedLocation.value = property;
}

watch(selectedLocation, (location) => {
    emit('update:location', location);
});
</script>
